import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'tooltipDisabled',
})
export class TooltipDisabledPipe implements PipeTransform {
    transform(text: string | null | undefined, maxLength: number): boolean {
        return !text || text.length <= maxLength;
    }
}
